export default __webpack_public_path__ + "static/media/backgroundSm.0f0620f1.webp";